import { Button, DataTableColumnHeader } from "@/components/ui";
import type { MassTortSurvey } from "@/lib/data/requests/mass-torts/mass-tort-survey";
import type { ColumnDef } from "@tanstack/react-table";

export function massTortSurveyTableColumns({
  onView,
  onDistribute,
}: {
  onView: (survey: MassTortSurvey) => void;
  onDistribute?: (survey: MassTortSurvey) => void;
}): ColumnDef<MassTortSurvey>[] {
  return [
    {
      accessorKey: "title",
      id: "Survey",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => (
        <button
          type="button"
          className="block max-w-64 min-w-32 truncate text-left font-medium"
          title={row.original.title}
          onClick={(event) => {
            event.stopPropagation();
            onView(row.original);
          }}
        >
          {row.original.title}
        </button>
      ),
    },
    {
      accessorFn: (survey) => survey.description ?? "",
      id: "Description",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => (
        <span
          className="text-muted-foreground block max-w-64 truncate"
          title={row.original.description ?? undefined}
        >
          {row.original.description || "—"}
        </span>
      ),
    },
    {
      accessorKey: "expirationDays",
      id: "Response window",
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      cell: ({ row }) => `${row.original.expirationDays} days`,
    },
    ...(onDistribute
      ? [
          {
            id: "Actions",
            header: () => (
              <span className="text-muted-foreground font-normal">Actions</span>
            ),
            cell: ({ row }: { row: { original: MassTortSurvey } }) => (
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={(event) => {
                  event.stopPropagation();
                  onDistribute(row.original);
                }}
              >
                Distribute survey
              </Button>
            ),
          },
        ]
      : []),
  ];
}
